import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../_metronic/_partials/controls";
import {
  createOrganizationRegional,
  fetchOrganizationRegionalById,
  updateOrganizationRegional
} from "../../../_redux/organization-regional/organizationRegionalAction";
import LoadingAnimation from "../loading-animation/LoadingAnimation";
import OrganizationRegionalEditForm from "./OrganizationRegionalEditForm";

export default function OrganizationRegionalForm({
  history,
  match: {
    params: { id }
  }
}) {
  const dispatch = useDispatch();

  const { organizationRegionalForEdit, actionsLoading } = useSelector(
    state => state.superAdminOrganizationRegional,
    shallowEqual
  );

  useEffect(() => {
    if (id) {
      dispatch(fetchOrganizationRegionalById(id));
    }
  }, [dispatch, id]);

  const saveRegional = values => {
    if (id) {
      dispatch(updateOrganizationRegional(values)).then(res => {
        toast.success(res.data.message);
        history.push("/admin/master-data/regional");
      });
    } else {
      dispatch(createOrganizationRegional(values)).then(res => {
        toast.success(res.data.message);
        history.push("/admin/master-data/regional");
      });
    }
  };

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      <Card>
        <CardHeader title={`${id ? "Edit" : "Tambah"} Regional`}>
          {/* <CardHeaderToolbar>
            <button type="button" className="btn mx-1 btn-warning">
              Pencarian
            </button>
          </CardHeaderToolbar> */}
        </CardHeader>
        <CardBody>
          <OrganizationRegionalEditForm
            defaultValues={id ? organizationRegionalForEdit || {} : {}}
            onSubmit={saveRegional}
          />
        </CardBody>
      </Card>
    </>
  );
}
